import { all, call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {
  NotificationAction,
  TicketAction,
  UploadImageAction
} from "../actions";
import * as ticketApi from "../api/ticket";
import { toastr } from "react-redux-toastr";
import imageCompression from "browser-image-compression";
import { SetMessage } from "../assets/errorMessages";

export function* watcherTicket() {
  yield takeLatest(types.TICKET_LIST_REQUEST, list);
  yield takeLatest(types.TICKET_STORE_REQUEST, store);
  yield takeLatest(types.TICKET_UPDATE_REQUEST, update);
  yield takeLatest(types.TICKET_SHOW_REQUEST, get);
}

function getList() {
  return ticketApi.getList();
}

function* list() {
  try {
    const response = yield call(getList);
    yield put(TicketAction.getListSuccess(response.data.data));
    yield put(
      NotificationAction.setNotificationCount({
        ticket: response.data.unread_feedbacks
      })
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(TicketAction.getListFailure(message));
  }
}

function storeReq(data) {
  return ticketApi.store(data);
}

function* storeImageReq(ticketId, messageId, file, index) {
  if (!file.id) {
    const options = {
      maxSizeMB: 0.7,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    try {
      const compressedResult = yield call(imageCompression, file, options);
      const responseImg = yield call(
        ticketApi.storeImage,
        compressedResult,
        ticketId,
        messageId
      );
      yield put(UploadImageAction.uploadImageSuccess(index));
      return responseImg;
    } catch (error) {
      toastr.error("", `ارسال عکس ${index + 1} با خطا رو‌به‌رو شد.`);
      yield put(UploadImageAction.uploadImageFailure(index));
      return error;
    }
  }
}

function* store(action) {
  try {
    yield put(UploadImageAction.showModal(action.data.files));
    const response = yield call(storeReq, action.data);
    const data = response.data;
    yield put(UploadImageAction.uploadImageRequest(action.data.files));
    yield all(
      action.data.files.map((file, i) =>
        storeImageReq(data.ticket_id, data.data.id, file, i)
      )
    );
    yield put(UploadImageAction.hideModal());
    data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const listResponse = yield call(getList);
    yield put(TicketAction.getListSuccess(listResponse.data.data));
    yield put(TicketAction.storeSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(TicketAction.storeFailure());
    yield put(UploadImageAction.hideModal());
  }
}

function getReq(id) {
  return ticketApi.get(id);
}

function* get(action) {
  try {
    const response = yield call(getReq, action.id);
    yield put(TicketAction.getSuccess(response.data.data));
    yield put(
      NotificationAction.setNotificationCount({
        ticket: response.data.unread_feedbacks
      })
    );
  } catch (error) {
    const message = SetMessage(error);
    yield put(TicketAction.getFailure(message));
  }
}

function updateReq(id, data) {
  return ticketApi.update(id, data);
}

function* update(action) {
  try {
    yield put(UploadImageAction.showModal(action.data.files));
    const response = yield call(updateReq, action.id, action.data);
    const data = response.data;
    yield put(UploadImageAction.uploadImageRequest(action.data.files));
    yield all(
      action.data.files.map((file, i) =>
        storeImageReq(data.ticket_id, data.data.id, file, i)
      )
    );
    yield put(UploadImageAction.hideModal());
    data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const ticketResponse = yield call(getReq, action.id);
    yield put(TicketAction.updateSuccess());
    yield put(TicketAction.getSuccess(ticketResponse.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(TicketAction.updateFailure());
    yield put(UploadImageAction.hideModal());
  }
}
